const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Resolve a photo/profile image path to a fully-qualified URL.
// Relative paths (e.g. "/api/photos/{id}/public") are prefixed with the
// backend origin so images load regardless of the frontend's own origin.
export const resolveImageUrl = (src) => {
  if (!src) return '';
  if (src.startsWith('http') || src.startsWith('data:') || src.startsWith('blob:')) return src;
  return `${BACKEND_URL}${src}`;
};
